import { Injectable } from '@angular/core';



@Injectable()
export class QuizService {
  // Saved variables for the current quiz, for the current track
  quizKey = '';
  quizPushToSis = false;
  trackKey = '';
  trackTitle = '';



  constructor() {
  }




  
}
